// extracted by mini-css-extract-plugin
export default {"inputStyles":"pure-input_inputStyles__J6GRk"};